import AxiosInstance from '../config/AxiosInstance';

export type SalesOverviewParams = {
  from?: string;
  to?: string;
  compareFrom?: string;
  compareTo?: string;
  locationId?: string;
  tz?: string;
};

const getSalesOverview = async (params: SalesOverviewParams) => {
  try {
    const cleanParams = Object.entries(params).reduce<Record<string, string>>((acc, [key, value]) => {
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});

    const { data } = await AxiosInstance.get('/api/inventory/reporting/sales-overview', {
      params: cleanParams,
    });
    return { data };
  } catch (error) {
    throw error;
  }
};

export { getSalesOverview };
